import { axios } from "../../config/axiosConfig";
import { endpoints } from "../../config/apiConfig";

async function getUserActivityLogs(payload) {
    return axios
    .post(endpoints.customers.getUserActivities, payload)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return null;
    });
};
async function getUserActivityControllerList() {
    return axios
    .post(endpoints.customers.getUserActivitiesControllerList)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return null;
    });
};
async function getUserActivityActionList() {
    return axios
    .post(endpoints.customers.getUserActivitiesActionList)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return null;
    });
};

export const activityLogsApi = {
    getUserActivityLogs: getUserActivityLogs,
    getUserActivityControllerList: getUserActivityControllerList,
    getUserActivityActionList: getUserActivityActionList,
};
